import React from 'react'
import { ResizeObserver as Polyfill } from '@juggle/resize-observer'

const ResizeObserver = window.ResizeObserver || Polyfill

function useResizeObserver(ref) {
  const [dimensions, setDimensions] = React.useState(null)
  React.useEffect(() => {
    if (ref.current) {
      const target = ref.current
      const resizeObserver = new ResizeObserver((entries) =>
        entries.forEach((entry) => setDimensions(entry.contentRect))
      )
      resizeObserver?.observe(target)
      return () => {
        resizeObserver?.unobserve(target)
      }
    }
  }, [ref])
  return dimensions
}
export default useResizeObserver
